import $ from 'jquery';
import {CompareModule} from "../../services/compare/Compare";
import {scrollbars} from "../../scripts/initCompare";
import {size} from "../../scripts/config";

const removeFromCompareV1Semantics = {
    'containerSelector': '.remove-from-compare-v1',
    'virtualModifierIdAttributeName': 'data-remove-from-compare-v1-virtual-modifier-id',
    'isInCompareAttributeName': 'data-remove-from-compare-v1-is-in-compare',
    'productTypeIdAttributeName': 'data-remove-from-compare-v1-product-type-id',
    'idAttributeName': 'data-remove-from-compare-v1-id',
    'rootElement': '.compare__inner',
    //deps
    'dependParentRemoveSelector': '.product-card-v2',
};

$(function () {
    let removeFromCompareV1 = new RemoveFromCompareV1();
    removeFromCompareV1.subscribe();
});

class RemoveFromCompareV1 {
    subscribe() {
        let self = this;
        $(document).on(
            'click',
            removeFromCompareV1Semantics.containerSelector,
            function (e) {
                e.preventDefault();
                let initiatorElement = $(e.currentTarget);
                let rootElement = initiatorElement.closest(removeFromCompareV1Semantics.rootElement);
                CompareModule.list.addOrChange(
                    initiatorElement.attr(
                        removeFromCompareV1Semantics
                            .productTypeIdAttributeName
                    ),
                    initiatorElement.attr(
                        removeFromCompareV1Semantics
                            .idAttributeName
                    ),
                    initiatorElement.attr(
                        removeFromCompareV1Semantics
                            .virtualModifierIdAttributeName
                    ),
                );
                // initiatorElement.closest(removeFromCompareV1Semantics.dependParentRemoveSelector).detach();
                if (window.innerWidth >= size.smDesktop) {
                    const $this = initiatorElement;
                    const $slide = $this.closest('.js-compare-slide');
                    const goodId = $slide.data('good');
                    rootElement.find(`.js-compare-value`).each(function () {
                        const $this = $(this);
                        if ($this.data('good') === goodId) {
                            $this.remove();
                        }
                    });
                    rootElement.find(`.js-compare-slide[data-good="${goodId}"]`).each(function () {
                        const $slide = $(this);

                        if (!$slide.is(':visible')) {
                            $slide.remove();
                            return
                        }

                        $slide.on('animationend', function () {
                            $(this).remove();
                            if ($('.js-compare-slide').length === 0) {
                                $('.js-compare-section').addClass('_empty')
                            }
                        });

                        $slide.addClass("_remove-animation");

                    })
                } else {
                    const $slider = initiatorElement.closest('.js-compare-slider-left, .js-compare-slider-right');

                    const slick = $slider.slick('getSlick');
                    let index = slick.currentSlide;
                    const goodId = slick.$slides[index].dataset.good;
                    rootElement.find(`.js-compare-value[data-good="${goodId}"]`).remove();

                    rootElement.find('.js-compare-slider-left, .js-compare-slider-right').each(function () {
                        const slick = $(this).slick('getSlick');
                        slick.removeSlide(index);

                        changePaging(slick, slick.currentSlide);
                        changeValues(slick, slick.currentSlide);
                    });
                }
                let isOnlyDiffActive = rootElement.find('.js-only-diff').hasClass('_active');
                // вынести в функцию
                if (isOnlyDiffActive) {
                    rootElement.find('.js-compare-item').each(function () {
                        let value
                        let isEqual = true
                        $(this).find('.js-compare-value[data-slider="1"]').each(function () {
                            if (!value) {
                                value = $(this).text();
                            } else if (value !== $(this).text()) {
                                isEqual = false;
                            }
                        });

                        if (isEqual) {
                            $(this).addClass('_hidden');
                        } else {
                            $(this).removeClass('_hidden');
                        }
                    });
                } else {
                    rootElement.find('.js-compare-item').removeClass('_hidden');
                }
                let ps = scrollbars.get(rootElement.find('.js-compare-scrollbar'));
                if (ps) ps.update();
            }
        )
    }
}